// src/components/cart/addToCartButton.jsx - COMPLETELY FIXED
import React, { useState,useEffect } from 'react';
import { useCart } from '../../context/cartContext';
import { toast } from 'react-toastify';

const AddToCartButton = ({ 
  product, 
  quantity = 1, 
  color = null, 
  className = '',
  showQuantity = false,
  fullWidth = true,
  onAddToCart = null
}) => {
  const { addItem } = useCart();
  const [isAdding, setIsAdding] = useState(false);
  const [itemQuantity, setItemQuantity] = useState(quantity);
  // Sync with parent quantity prop when it changes
useEffect(() => {
  setItemQuantity(quantity);
}, [quantity]);

  const handleQuantityChange = (e) => {
    const value = parseInt(e.target.value);
    if (value > 0) {
      setItemQuantity(value);
    }
  };

  const incrementQuantity = () => {
    setItemQuantity(prev => prev + 1);
  };

  const decrementQuantity = () => {
    if (itemQuantity > 1) {
      setItemQuantity(prev => prev - 1);
    }
  };

  const handleAddToCart = () => {
    if (!product) return;

    // ✅ CRITICAL: Validate minimum order quantity FIRST
    const minQty = product.minOrderQuantity || 1;
    
    if (itemQuantity < minQty) {
      toast.error(`Minimum order quantity for this product is ${minQty}`);
      return;
    }

    setIsAdding(true);

    try {
      // ✅ CRITICAL FIX: Convert stockLevel to numeric value
      let productStock = 0;
      
      if (product.stock || product.stockAvailable || product.quantity) {
        // If numeric stock exists, use it
        productStock = product.stock || product.stockAvailable || product.quantity || 0;
      } else if (product.stockLevel) {
        // Convert stockLevel string to number
        const stockLevelMap = {
          'high': 100,
          'medium': 50,
          'low': 10,
          'out_of_stock': 0,
          'out-of-stock': 0
        };
        productStock = stockLevelMap[product.stockLevel.toLowerCase()] || 0;
      } else if (product.isInStock) {
        // Fallback: if isInStock is true, assume available
        productStock = 999;
      }
      
      const productIsInStock = product.isInStock !== undefined ? 
                              product.isInStock : 
                              productStock > 0;
      
      const productStockStatus = product.stockStatus || 
                                (!productIsInStock ? 'OUT_OF_STOCK' :
                                 productStock <= 10 ? 'LOW_STOCK' : 'IN_STOCK');

      console.log('🛒 Adding to cart - Product data:', {
        productId: product.productId,
        rawStockLevel: product.stockLevel,
        rawIsInStock: product.isInStock,
        rawStockStatus: product.stockStatus,
        calculatedStock: productStock,
        calculatedIsInStock: productIsInStock,
        finalStockStatus: productStockStatus,
        minOrderQuantity: minQty,
        requestedQuantity: itemQuantity
      });

      // Get image URL
      let imageUrl = product.imageUrl;
      let thumbnailUrl = product.thumbnailUrl;
      
      if (!imageUrl && product.images && product.images.length > 0) {
        const defaultImage = product.images.find(img => img.isDefault) || product.images[0];
        imageUrl = defaultImage.url;
        thumbnailUrl = defaultImage.thumbnailUrl || defaultImage.url;
      }

      // ✅ Create cart item with ALL required fields
      const cartItem = {
        // Basic info
        productId: product.productId,
        name: product.name,
        price: product.price || product.sellingPrice,
        mrp: product.mrp,
        quantity: itemQuantity,
        color: color || product.color,
        sizeLabel: product.sizeLabel || null,
        
        // Category info
        
        // Category info
        category: product.category,
        subCategory: product.subCategory,
        
        // Product details
        material: product.material,
        brand: product.brand,
        manufacturer: product.manufacturer,
        
        // Physical specifications
        thickness: product.thickness,
        weight: product.weight,
        gsm: product.gsm,
        dimensions: product.dimensions,
        coverageArea: product.coverageArea,
        
        // Packaging
        piecesPerPack: product.packagingInfo?.piecesPerPack || product.piecesPerPack || 1,
        rollLength: product.packagingInfo?.rollLength || product.rollLength,
        rollWeight: product.packagingInfo?.rollWeight || product.rollWeight,
        
        // Order constraints
        minOrderQuantity: product.minOrderQuantity || 1,
        maxOrderQuantity: product.maxOrderQuantity,
        
        // Images
        imageUrl: imageUrl,
        thumbnailUrl: thumbnailUrl,
        
        // ✅ CRITICAL: Stock fields - Use calculated values
        stock: productStock,
        stockAvailable: productStock,
        isInStock: productIsInStock,
        stockStatus: productStockStatus,
        
        // Flags
        isEcoFriendly: product.isEcoFriendly || false,
        isBulkItem: product.isBulkItem || false,
        requiresSpecialHandling: product.requiresSpecialHandling || false,
        
        // Delivery
        estimatedDeliveryDays: product.estimatedDeliveryDays || 3,
        deliveryMessage: product.deliveryMessage || 'Delivery in 2-3 business days',
        
        // Optional
        customerNotes: '',
        urgency: 'WEEKLY'
      };

      console.log('✅ Cart item prepared:', {
        productId: cartItem.productId,
        stock: cartItem.stock,
        stockAvailable: cartItem.stockAvailable,
        isInStock: cartItem.isInStock,
        stockStatus: cartItem.stockStatus
      });

      // Add to cart
      addItem(cartItem);

      // Show success toast
      toast.success('Added to cart successfully!');

      // Call callback if provided
      if (onAddToCart) {
        onAddToCart(cartItem);
      }
    } catch (error) {
      toast.error('Failed to add item to cart');
      console.error('❌ Add to cart error:', error);
    } finally {
      setIsAdding(false);
    }
  };

  // ✅ CRITICAL FIX: Handle stockLevel field from your API
  let productStock = 0;
  
  if (product?.stock || product?.stockAvailable || product?.quantity) {
    // If numeric stock exists, use it
    productStock = product.stock || product.stockAvailable || product.quantity || 0;
  } else if (product?.stockLevel) {
    // Convert stockLevel string to number
    const stockLevelMap = {
      'high': 100,
      'medium': 50,
      'low': 10,
      'out_of_stock': 0,
      'out-of-stock': 0
    };
    productStock = stockLevelMap[product.stockLevel.toLowerCase()] || 0;
  } else if (product?.isInStock) {
    // Fallback: if isInStock is true, assume available
    productStock = 999;
  }
  
  const isOutOfStock = product?.isInStock === false || productStock <= 0;

  const buttonClasses = `bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed ${fullWidth ? 'w-full' : ''} ${className}`;

  return (
    <div>
      {showQuantity && (
        <div className="flex border rounded-md w-32 mb-3 mx-auto">
          <button
            className="w-10 h-10 flex items-center justify-center border-r text-gray-600 hover:bg-gray-100 disabled:opacity-50"
            onClick={decrementQuantity}
            disabled={itemQuantity <= 1}
          >
            -
          </button>
          <input
            type="number"
            value={itemQuantity}
            onChange={handleQuantityChange}
            className="w-12 h-10 text-center focus:outline-none"
            min="1"
            max={productStock || 999}
          />
          <button
            className="w-10 h-10 flex items-center justify-center border-l text-gray-600 hover:bg-gray-100 disabled:opacity-50"
            onClick={incrementQuantity}
            disabled={itemQuantity >= productStock}
          >
            +
          </button>
        </div>
      )}

      <button
        className={buttonClasses}
        onClick={handleAddToCart}
        disabled={isAdding || !product || isOutOfStock}
      >
        {isAdding ? (
          <span className="flex items-center">
            <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Adding...
          </span>
        ) : isOutOfStock ? (
          'Out of Stock'
        ) : (
          <>
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
            Add to Cart
          </>
        )}
      </button>
    </div>
  );
};

export default AddToCartButton;